var r={exports:{}};export{r as _};
//# sourceMappingURL=typeof.js.map
